export default __webpack_public_path__ + "static/media/captain.dd98a938.jpg";